
const firebaseConfig = {
   apiKey: "AIzaSyAlfNqsEeBy2eROOPlbPbOmOe25GYn3mEo",
   authDomain: "thirst-for-travel.firebaseapp.com",
   projectId: "thirst-for-travel",
   storageBucket: "thirst-for-travel.appspot.com",
   messagingSenderId: "1021634482491",
   appId: "1:1021634482491:web:b6f5cd31b331bd6f69a71e"
};

export default firebaseConfig;